// ConsultationNote.jsx
import React from 'react';

const ConsultationNote = ({ patient, noteContent, onNoteChange, onTemplateSelect }) => {
  const defaultPatient = {
    name: "Sarah Smith",
    age: 42,
    gender: "F",
    date: "November 15, 2023",
    visitType: "New Consultation"
  };

  const patientData = patient || defaultPatient;

  const handleChange = (field, value) => {
    if (onNoteChange) {
      onNoteChange(field, value);
    }
  };

  const handleTemplateDropdown = (e) => {
    if (onTemplateSelect) {
      onTemplateSelect(e.target.value);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-4 border-b flex justify-between items-center">
        <h2 className="text-xl font-medium">New Consultation Note</h2>
        <div>
          <select 
            className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
            onChange={handleTemplateDropdown}
            defaultValue=""
          >
            <option value="" disabled>Templates ▼</option>
            <option value="New Consultation">New Consultation</option>
            <option value="Follow-up Visit">Follow-up Visit</option>
            <option value="Treatment Review">Treatment Review</option>
            <option value="Chemotherapy Order">Chemotherapy Order</option>
          </select>
        </div>
      </div>
     
      <div className="p-4">
        <div className="mb-4">
          <p><strong>Patient:</strong> {patientData.name}, {patientData.age}{patientData.gender}</p>
          <p><strong>Date:</strong> {patientData.date}</p>
          <p><strong>Visit Type:</strong> {patientData.visitType}</p>
        </div>
       
        <div className="mb-4">
          <label className="block font-medium mb-1">Chief Complaint:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows="2"
            value={noteContent.chiefComplaint}
            onChange={(e) => handleChange('chiefComplaint', e.target.value)}
          ></textarea>
        </div>
       
        <div className="mb-4">
          <label className="block font-medium mb-1">History of Present Illness:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows="3"
            value={noteContent.historyOfPresentIllness}
            onChange={(e) => handleChange('historyOfPresentIllness', e.target.value)}
          ></textarea>
        </div>
       
        <div className="mb-4">
          <label className="block font-medium mb-1">Oncology-Relevant Past Medical History:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows="3"
            value={noteContent.medicalHistory}
            onChange={(e) => handleChange('medicalHistory', e.target.value)}
          ></textarea>
        </div>
       
        <div className="mb-4">
          <label className="block font-medium mb-1">Labs & Diagnostic Results:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows="4"
            value={noteContent.diagnosticResults}
            onChange={(e) => handleChange('diagnosticResults', e.target.value)}
          ></textarea>
        </div>
       
        <div className="mb-4">
          <label className="block font-medium mb-1">Assessment:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows="3"
            value={noteContent.assessment}
            onChange={(e) => handleChange('assessment', e.target.value)}
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default ConsultationNote;